import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import dayjs from "dayjs";
import "dayjs/locale/en";
import locale from "antd/locale/en_US";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { RecoilRoot } from "recoil";

// Set dayjs locale to English globally - force update
dayjs.locale("en", null, true);

// Ensure dayjs uses English for all date operations
if (typeof dayjs.locale === "function") {
  dayjs.locale("en");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(views.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
